import * as types from './ActionTypes';

function getSelected(contents, selectedModule, startPage) {
  const selected = {
    topic: 0,
    act: 0,
    content: null,
    behavior: 'ask',
  };

  contents.forEach((topic, topicIndex) => {
    topic.children.forEach((act, actIndex) => {
      act.children.forEach((content) => {
        if (selected.content === null) selected.content = content.id.toString();

        if (selectedModule === null) return;

        if (content.id.toString() === selectedModule.toString()) {
          selected.topic = topicIndex;
          selected.act = actIndex;
          selected.content = selectedModule.toString();
          selected.behavior = content.behavior;
        }
      });
    });
  });

  if (selectedModule === null && !startPage) {
    let url = window.location.origin + window.location.pathname + window.location.search;
    url += `#${selected.content}`;
    window.location = url;
  }

  return selected;
}

function getModules(contents) {
  const modules = [];

  contents.forEach((topic) => {
    topic.children.forEach((act) => {
      act.children.forEach((content) => {
        modules.push(content);
      });
    });
  });

  return modules;
}

function getFiltered(contents, filter) {
  const filtered = [];

  contents.forEach((topic, topicIndex) => {
    let topicShow = true;
    let actShow = true;
    let contentShow = true;

    let actShowCount = topic.children.length;
    let contentShowCount = 0;

    if ((topic.type === 'separate' && filter)
    || topic.name.toLowerCase().indexOf(filter) === -1) topicShow = false;

    filtered.push({
      name: topic.name,
      id: topic.id || "",
      type: topic.type,
      show: topicShow,
      children: [],
    });

    topic.children.forEach((act, actIndex) => {
      contentShowCount = act.children.length;

      if (act.name.toLowerCase().indexOf(filter) === -1) {
        actShow = false;
        actShowCount -= 1;
      } else {
        actShow = true;
      }

      filtered[topicIndex].children.push({
        name: act.name,
        id: act.id || "",
        revision: act.revision ? act.revision : 'false',
        show: actShow,
        children: [],
      });

      act.children.forEach((content) => {
        if (content.name.toLowerCase().indexOf(filter) === -1) {
          contentShow = false;
          contentShowCount -= 1;
        } else {
          contentShow = true;
        }

        filtered[topicIndex].children[actIndex].children.push({
          name: content.name,
          behavior: content.behavior,
          code: content.code,
          show: contentShow,
          opened: content.opened !== undefined ? content.opened : 'true',
          finished: content.finished !== undefined ? content.finished : 'false',
          id: content.id.toString(),
        });
      });

      if (contentShowCount !== 0) {
        if (!actShow) {
          filtered[topicIndex].children[actIndex].show = true;
          actShowCount += 1;
        }
      }
    });
    if (actShowCount !== 0) {
      if (!topicShow) {
        filtered[topicIndex].show = true;
      }
    }
  });

  return filtered;
}

export function fillGlossary(glossary) {
  return {
    type: types.FILL_GLOSSARY,
    glossary,
  };
}

export function fillStartPage(startPage) {
  return {
    type: types.FILL_START_PAGE,
    startPage,
  };
}


export function fillCommonData(data) {
  return {
    type: types.FILL_COMMON_DATA,
    data,
  };
}

export function setTopic(topic) {
  return {
    type: types.SET_TOPIC,
    topic,
  };
}

export function filterContent(contents, filter) {
  return (dispatch) => new Promise((resolve) => {
    const filtered = getFiltered(contents, filter);
    dispatch(
      {
        type: types.UPDATE_CONTENT,
        contents: filtered,
      },
    );
    resolve(filtered);
  });
}

export function setAct(act) {
  return {
    type: types.SET_ACT,
    act,
  };
}

export function setSelectedContent(content) {
  return (dispatch) => new Promise((resolve) => {
    dispatch(
      {
        type: types.SET_SELECTED_CONTENT,
        content,
      },
    );
    resolve();
  });
}

export function openContent(contents, moduleId) {
  return (dispatch) => new Promise((resolve) => {
    const newContents = [];

    contents.forEach((topic, topicIndex) => {
      newContents.push({
        name: topic.name,
        type: topic.type,
        show: topic.show,
        children: [],
      });
      topic.children.forEach((act, actIndex) => {
        newContents[topicIndex].children.push({
          name: act.name,
          revision: act.revision,
          show: act.show,
          children: [],
        });
        act.children.forEach((content) => {
          newContents[topicIndex].children[actIndex].children.push({
            name: content.name,
            behavior: content.behavior,
            code: content.code,
            show: content.show,
            opened: content.id.toString() === moduleId.toString() ? 'true' : content.opened,
            finished: content.finished,
            id: content.id,
          });
        });
      });
    });

    dispatch(
      {
        type: types.UPDATE_CONTENT,
        contents: newContents,
      },
    );
    resolve(newContents);
  });
}

export function finishModule(contents, moduleId) {
  return (dispatch) => new Promise((resolve) => {
    const newContents = [];

    contents.forEach((topic, topicIndex) => {
      newContents.push({
        name: topic.name,
        type: topic.type,
        show: topic.show,
        children: [],
      });
      topic.children.forEach((act, actIndex) => {
        newContents[topicIndex].children.push({
          name: act.name,
          revision: act.revision,
          show: act.show,
          children: [],
        });
        act.children.forEach((content) => {
          newContents[topicIndex].children[actIndex].children.push({
            name: content.name,
            behavior: content.behavior,
            code: content.code,
            show: content.show,
            opened: content.opened,
            finished: content.id.toString() === moduleId.toString() ? 'true' : content.finished,
            id: content.id,
          });
        });
      });
    });

    dispatch(
      {
        type: types.UPDATE_CONTENT,
        contents: newContents,
      },
    );
    resolve(newContents);
  });
}

export function fillSelected(contents, selectedModule, startPage) {
  return (dispatch) => new Promise((resolve) => {
    const selected = getSelected(contents, selectedModule, startPage);
    dispatch(
      {
        type: types.FILL_SELECTED,
        selected,
      },
    );
    resolve(selected);
  });
}

export function fillModules(contents) {
  return {
    type: types.FILL_MODULES,
    modules: getModules(contents),
  };
}

// COMMENTS
export function fillComments(comments) {
  return {
    type: types.FILL_COMMENTS,
    comments,
  };
}

export function addComment(comment) {
  return {
    type: types.ADD_COMMENT,
    comment,
  };
}

export function removeComment(commentId) {
  return {
    type: types.REMOVE_COMMENT,
    commentId,
  };
}
// END COMMENTS

// FAVORITES
export function fillFavorites(favorites) {
  return {
    type: types.FILL_FAVORITES,
    favorites,
  };
}

export function addFavorites(favorites) {
  return {
    type: types.ADD_FAVORITES,
    favorites,
  };
}

export function removeFavorites(favoriteId) {
  return {
    type: types.REMOVE_FAVORITES,
    favoriteId,
  };
}

// END FAVORITES
